import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface PropTypes {
  children: React.ReactNode;
}
function WarningContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col justify-center items-center w-full h-[calc(100vh-120px)] md:h-[calc(100vh-64px)]">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default WarningContainer;